<template>
  <div id="modal" v-show="show" @click="closeModal">
    <transition name="modal">
      <div class="container" v-show="show" :style="style" v-on:click.stop>
        <transition name="modal-title" mode="out-in">
          <h1 class="title" v-html="title" :key="title" />
        </transition>
        <component :is="loadedComponent" :message="message" />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Modal",
  methods: {
    ...mapActions("modal", ["closeModal"])
  },
  computed: {
    ...mapGetters("modal", ["show", "component", "title", "message", "style"]),
    loadedComponent() {
      return this.component ? () => import(`./${this.component}/`) : "";
    }
  }
};
</script>

<style lang="scss" scoped>
#modal {
  position: fixed;
  z-index: 1100;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding-top: $modal-padding-top;
  background-color: $background-color-transparent-2;
  text-align: center;
  .container {
    display: inline-block;
    max-width: $modal-container-max-width;
    max-height: 85%;
    padding: $modal-container-padding;
    text-align: $modal-container-text-align;
    color: $color-clear-1;
    background-color: $background-color-clear-1;
    border-radius: $modal-container-border-radius;
    overflow-y: auto;
    .title {
      @extend #{$modal-title-font-size};
      width: 100%;
      margin: $modal-container-title-margin;
      text-align: $modal-container-title-text-align;
      font-weight: $modal-container-title-font-weight;
    }
  }
}

.modal-enter-active,
.modal-leave-active {
  transition-property: transform;
  transition-duration: $modal-transition-duration;
  transition-timing-function: $modal-transition-timing-function;
}

.modal-enter {
  transform: scale(0);
}

.modal-leave-to {
  transform: scale(0);
}

.modal-title-enter-active,
.modal-title-leave-active {
  transition-property: opacity;
  transition-duration: $modal-transition-duration;
  transition-timing-function: $modal-transition-timing-function;
}

.modal-title-enter,
.modal-title-leave-to {
  opacity: 0;
}
</style>